import { ReactNode } from "react";
import { Box, Stack } from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { sectionHeaderSx, sectionPanelSx } from "../configuracoes.theme";

type Props = {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  children: ReactNode;
};

export default function ConfigFormSection({ title, subtitle, icon, children }: Props) {
  return (
    <MDBox sx={sectionPanelSx}>
      <MDBox sx={sectionHeaderSx}>
        <Stack direction="row" spacing={1.5} alignItems="center" minWidth={0}>
          {icon ? (
            <Box sx={{ display: "flex", color: "#F96030", flexShrink: 0 }}>{icon}</Box>
          ) : null}
          <Box minWidth={0}>
            <MDTypography variant="h6" fontWeight="bold">
              {title}
            </MDTypography>
            {subtitle ? (
              <MDTypography variant="caption" color="text.secondary" display="block">
                {subtitle}
              </MDTypography>
            ) : null}
          </Box>
        </Stack>
      </MDBox>
      <MDBox p={3}>{children}</MDBox>
    </MDBox>
  );
}
